import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { ISalesFunnel } from '@user/store/salesFunnel'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { useData, useHandlers } from './hooks'

type Props = {
  name: string
  label: string
  salesFunnels: ISalesFunnel[]
  disabled: boolean
  onChange: (value: ISalesFunnel | null) => void
  required?: boolean
}

export function SalesFunnelSelect(props: Props) {
  const { name, salesFunnels, disabled, onChange, required, ...rest } = props
  const {
    selectedOption,
    isSubmitting,
    showError,
    helperText,
    ...restUseData
  } = useData({ name, salesFunnels, required })
  const { handleChange } = useHandlers({ name })

  return (
    <Box>
      <Select<ISalesFunnel>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        error={showError}
        required={required !== undefined ? required : true}
        onChange={(value) => {
          onChange(value)
          handleChange(value)
        }}
        value={selectedOption}
        optionMode={'normal'}
        testId="leadAssignmentSalesFunnelInput"
        textFieldProps={{
          InputProps: {
            sx: {
              background: 'white',
            },
          },
        }}
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  )
}
